import {
  bool, func, string
} from 'prop-types';

/* istanbul ignore next */
export const defaultProps = {
  itemId: '',
  selectedItemId: '',
  setIsEntryDrawerOpen: () => {},
  ssr: false,
  projectId: null,
  isEntryDrawerOpen: false,
  isEntryPoint: false
};

/* istanbul ignore next */
export const propTypes = {
  itemId: string,
  selectedItemId: string,
  setIsEntryDrawerOpen: func,
  ssr: bool,
  projectId: string,
  isEntryDrawerOpen: bool,
  isEntryPoint: bool
};

export const getCartData = (setItemIds) => {
  const intervalID = setInterval(() => {
    let count = 0;
    if (!window?.THDCart || count >= 10) {
      count += 1;
      return;
    }
    clearInterval(intervalID);

  // eslint-disable-next-line no-unused-expressions
  window?.THDCart?.getCartData().then((cartData) => {
    const cartItemIds = cartData?.CartModel?.itemModels?.map((item, index) => {
      return item?.itemId;
    });
    const uniqueCartItemIds = [...new Set(cartItemIds)];
    // Api call can to get nValues can only handle 16 items
    setItemIds(uniqueCartItemIds?.slice(0, 16) || []);
  });
  }, 100);
};

export const getIsAddedToCart = ({ cartNValues, categoryNValue }) => {
  return cartNValues.some((value) => {
    return !!value && categoryNValue.includes(value);
  });
};

export const getProductBreadcrumbs = ({ products, productError }) => {
  if (!products || productError || !products.length) return [];

  let breadCrumbs = [];
  products.forEach((product) => {
    breadCrumbs = [...breadCrumbs, ...product?.taxonomy?.breadCrumbs];
  });

  return breadCrumbs.map((crumb) => {
    return crumb.url?.split('/N-')[1];
  });
};

/**
 * This function grabs all nested mycart iframes and checks to see which has the project shopping portal node rendered.
 * An element is returned if one exists.
 * @param {string} selector ex: '#project-shopping-portal'
 * @returns HTMLElement
 */
export const querySelectorAllInIframes = (selector, fromBSSDrawer) => {
  let element;

  // eslint-disable-next-line consistent-return
  const recurse = (contentWindow = window) => {
    try {
      const iframes = contentWindow.document.body.querySelectorAll('iframe');
      iframes.forEach((iframe) => recurse(iframe.contentWindow));

      // if ATC not fired from bss, skip and look for another ATC drawer
      if (!fromBSSDrawer && contentWindow?.frameElement?.baseURI?.includes('/cart/bss')) {
        return null;
      }

      const selectedElement = contentWindow.document.body.querySelector(selector);
      if (selectedElement) {
        element = selectedElement;
      }
    } catch (error) {
      return null;
    }
  };

  recurse();

  return element;
};

export const setTailwindStyles = (fetchedPortalNode) => {
  const iframeHead = fetchedPortalNode?.closest('html')?.querySelector('head');
  const styleTags = document?.head?.querySelectorAll('style');
  let tailwindStyles;
  styleTags.forEach((style) => {
    if (style?.innerHTML?.includes('tailwind')) {
      tailwindStyles = style;
    }
  });
  // Fix image display change caused by tailwind css reset.
  // TODO: Add fix for image display default to cart
  const imgStyleReset = '.drawerItemAdded__payPal > img {display: inline}';
  const drawerStyleReset = '.cartTotalBox, .drawer-header, .drawerItemAdded { line-height: initial}';
  const cartStyleReset = `${imgStyleReset} ${drawerStyleReset}`;
  const newStyle = document.createElement('style');
  newStyle.innerHTML = `${tailwindStyles?.innerHTML}${cartStyleReset}`;
  // Add to the top of head so other stylesheets are applied after tailwind reset styles.
  return iframeHead.insertBefore(newStyle, iframeHead.firstChild);
};